import { render, staticRenderFns } from "./NewSolicitudeStockView.vue?vue&type=template&id=6eca54ea&lang=pug"
import script from "./NewSolicitudeStockView.vue?vue&type=script&lang=js"
export * from "./NewSolicitudeStockView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports